/**
 * PCS-11271: Amplitude event names + flat payload builders for the Toriut trial
 * lifecycle flow. Payloads must never carry the free-text feedback string —
 * only `has_freeform_feedback` (boolean) may hint at its presence.
 */
export const TORIUT_TRIAL_EVENTS = Object.freeze({
  EXPIRATION_PAGE_VIEWED: 'ToriutTrialExpirationPageViewed',
  GET_ACCESS_CLICKED: 'ToriutTrialGetAccessClicked',
  GET_ACCESS_PAGE_VIEWED: 'ToriutTrialGetAccessPageViewed',
  BOOK_DEMO_CLICKED: 'ToriutTrialBookDemoClicked',
  START_CHAT_CLICKED: 'ToriutTrialStartChatClicked',
  DONT_CONTINUE_CLICKED: 'ToriutTrialDontContinueClicked',
  CANCELLATION_REASONS_SUBMITTED: 'ToriutTrialCancellationReasonsSubmitted',
  CANCELLATION_DETAILS_CONTINUED: 'ToriutTrialCancellationDetailsContinued',
  CANCELLATION_DETAILS_SKIPPED: 'ToriutTrialCancellationDetailsSkipped',
  FEEDBACK_CALL_VIEWED: 'ToriutTrialFeedbackCallViewed',
  FEEDBACK_CALL_CLICKED: 'ToriutTrialFeedbackCallClicked',
  FEEDBACK_CALL_DECLINED: 'ToriutTrialFeedbackCallDeclined',
  CLOSE_ACCOUNT_PAGE_VIEWED: 'ToriutTrialCloseAccountPageViewed',
  RESTRICT_PROCESSING_CLICKED: 'ToriutTrialRestrictProcessingClicked',
  DELETE_PERSONAL_DATA_CLICKED: 'ToriutTrialDeletePersonalDataClicked',
  DATA_DELETION_SUBMITTED_PAGE_VIEWED: 'ToriutTrialDataDeletionSubmittedPageViewed',
  DATA_RESTRICTION_SUBMITTED_PAGE_VIEWED: 'ToriutTrialDataRestrictionSubmittedPageViewed',
  DATA_REQUEST_LOGOUT_CLICKED: 'ToriutTrialDataRequestLogoutClicked',
  WORKSPACE_DATA_DELETED_PAGE_VIEWED: 'ToriutTrialWorkspaceDataDeletedPageViewed',
});

export const SKIP_STAGE = Object.freeze({
  DETAILED_FEEDBACK: 'detailed_feedback',
});

/** Flat `{ reasons, reason_count }` payload shared by most reason-aware events. */
export const getReasonsPayload = (reasons = []) => ({
  reasons: Array.isArray(reasons) ? [...reasons] : [],
  reason_count: Array.isArray(reasons) ? reasons.length : 0,
});

export const getCancellationReasonsSubmittedPayload = (reasons = []) => getReasonsPayload(reasons);

export const getCancellationDetailsContinuedPayload = (reasons = [], hasFreeformFeedback = false) => ({
  ...getReasonsPayload(reasons),
  has_freeform_feedback: Boolean(hasFreeformFeedback),
});

export const getCancellationDetailsSkippedPayload = (reasons = []) => ({
  ...getReasonsPayload(reasons),
  skip_stage: SKIP_STAGE.DETAILED_FEEDBACK,
});

export const getFeedbackCallPayload = (reasons = []) => getReasonsPayload(reasons);
